import Vue from 'vue'
import Vuex from 'vuex'
// import router,{resetRouter} from "@/router";
import router from "@/router"
import {clearLoginState} from "@/utils/auth";

Vue.use(Vuex)

const store = new Vuex.Store({
    // state: {
    //     currentPathName: ''
    // },
    mutations: {
        // setPath (state) {
        //     // state.currentPathName = localStorage.getItem("currentPathName")
        // },
        logout() {
            // 清空缓存
            console.log('退出')
            clearLoginState()
            // localStorage.removeItem("menus")
            router.push("/login")

            //重置路由
            // resetRouter()
        }
    }
})

export default store
